import styled from 'styled-components'

import breakpoints from '../../../../theme/breakpoints'
import DeclarationFormLayout from '../../../../layouts/DeclarationFormLayout'
import FormikForm from '../../../form/FormikForm'
import ActionButton from '../../../ActionButton'
import UnderlineTitle from '../../../UnderlineTitle'
import FormFieldToggleButtonGroup from '../../../form/fields/FormFieldToggleButtonGroup'
import FormFieldInput from '../../../form/fields/FormFieldInput'
import FormFieldSelect from '../../../form/fields/FormFieldSelect'
import FormErrors from '../../../form/FormErrors'
import CDeclarationEntry from '../../../DeclarationEntry'
import CDeclarationTable from '../../../DeclarationTable'
import CDeclarationBlock from '../../../DeclarationBlock'
import CDeclarationAddMember from '../../../DeclarationAddMember'
import CDeclarationMemberList from '../../../DeclarationMemberList'
import FormSubmitButton from '../../../form/FormSubmitButton'
import Text from '../../../Text'
import CHtml from '../../../Html'

export const Container = styled.div`
  width: 100%;
  height: 100%;
`

export const FormLayout = styled(DeclarationFormLayout)`
  width: 100%;
  height: 100%;
  margin-bottom: 2rem;
`

export const Step = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 4rem;
  padding: 0 1.6rem;
`

export const StepHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 4rem;
`

export const StepPart = styled(UnderlineTitle)``

export const StepButton = styled(FormSubmitButton)<{ $isMobile?: boolean }>`
  display: ${({ $isMobile }) => ($isMobile ? 'flex' : 'none')};
  align-self: center;
  padding: 0.9rem 1.6rem;
  margin-top: ${({ $isMobile }) => ($isMobile ? '4rem' : '0')};
  ${breakpoints.up('tablet')} {
    display: ${({ $isMobile }) => ($isMobile ? 'none' : 'flex')};
  }
`

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin: 4rem 0;
`

export const ConfirmationButton = styled(FormSubmitButton)``

export const StepLabel = styled.div`
  ${({ theme }) => theme.textStyles.H4}
  margin-bottom: 2rem;
`

export const StepText = styled.div`
  ${({ theme }) => theme.textStyles.textLarge}
  margin-bottom: 2rem;
  margin-top: -0.4rem;
`

export const StepHtml = styled(CHtml)`
  ${({ theme }) => theme.textStyles.textLarge};
  color: ${({ theme }) => theme.colors.nightRider};
  line-height: 1.4;

  ul {
    padding-bottom: 3rem;
    margin: 0;
    padding-left: 2.5rem;
  }
`

export const StepFields = styled.div``

export const StepErrors = styled(FormErrors)``

export const ToggleGroup = styled(FormFieldToggleButtonGroup)``

export const Input = styled(FormFieldInput)``

export const Select = styled(FormFieldSelect)``

export const Button = styled(ActionButton)``

export const DeclarationEntry = styled(CDeclarationEntry)``

export const DeclarationTable = styled(CDeclarationTable)`
  margin-bottom: 2.4rem;

  ${breakpoints.up('tablet')} {
    margin-bottom: 4rem;
  }
`

export const DeclarationBlock = styled(CDeclarationBlock)`
  margin-bottom: 2.4rem;

  ${breakpoints.up('tablet')} {
    margin-bottom: 4rem;
  }
`

export const DeclarationAddMember = styled(CDeclarationAddMember)``

export const DeclarationMemberList = styled(CDeclarationMemberList)``

export const CenteredText = styled(Text)``
